module.exports = __webpack_public_path__ + "static/img/21-0623-cover.424588c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/21-0623-cover.jpg
// module id = ciTR
// module chunks = 0